import { Button } from "@maxhub/max-ui"

export const ButtonDefaultExample = {
    title: 'Button',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [],

    Preview(){
        return (
            <Button
                variant="primary"
                onClick={() => {}}
                size="medium"
            >
                Button
            </Button>
        )
    },

    getCode(){
        return `<Button
  variant="primary"
  onClick={() => {}}
  size="medium"
>
  Button
</Button>`
    }
}